import { Link } from "react-router-dom";
import { Phone, Check } from "lucide-react";
import SEO from "@/components/SEO";
import { PHONE, PHONE_TEL } from "@/components/PublicLayout";

const INCLUDED = [
  {
    title: "Hob & Oven",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/wingman/1b579b6a-2d4e-44eb-97e9-b3d7a8a3bfc9/attachments/5164c4913aaf4aca8e731e0b5275174a_IMG_2992.jpeg",
    alt: "Oven, hob and full kitchen run inside our temporary kitchen trailer",
    text: "Cook proper family meals throughout your project. Every trailer for mobile kitchen hire in Surrey includes a full hob and oven, so nothing about dinner time has to change.",
  },
  {
    title: "Fridge",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/wingman/1b579b6a-2d4e-44eb-97e9-b3d7a8a3bfc9/attachments/490bfa339c2e4e93b3493d3a76f04c16_IMG_2994.jpeg",
    alt: "Our temporary kitchen trailer set up on a customer's driveway with door open",
    text: "Keep your weekly shop fresh with a proper fridge included as standard. No cool boxes, no daily trips to the shops — just a normal kitchen routine.",
  },
  {
    title: "Dishwasher",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/wingman/1b579b6a-2d4e-44eb-97e9-b3d7a8a3bfc9/attachments/26cf82a70e1c40efab94b17606f02420_IMG_2993.jpeg",
    alt: "Sink, marble worktop, gas hob and dishwasher inside our mobile kitchen trailer",
    text: "A built-in dishwasher keeps on top of the washing up while the builders are in — one less thing to worry about during your renovation.",
  },
  {
    title: "Washing Machine",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/wingman/1b579b6a-2d4e-44eb-97e9-b3d7a8a3bfc9/attachments/2002b419603b4f3db90340e8a54a7a7e_IMG_2990.jpeg",
    alt: "Mobile kitchen trailer parked on a residential driveway in Surrey",
    text: "Our temporary kitchen hire Surrey trailers include a washing machine too, so school uniforms, work clothes and family laundry carry on as normal.",
  },
];

const EXTRAS = [
  "Sink with hot and cold running water",
  "Full plumbing and electrical connection by our team",
  "Worktop space and storage",
  "Heating for year-round comfort",
  "Lighting and power sockets",
  "Positioned on your drive or garden",
];

export default function WhatsIncluded() {
  return (
    <div data-testid="whats-included-page">
      <SEO
        title="Temporary Kitchen Trailer Hire — What's Included | Mobile Kitchen Company Surrey"
        description="Everything included with our mobile kitchen hire Surrey pods: hob, oven, fridge, dishwasher and washing machine. Fully equipped temporary kitchen hire across Surrey."
      />
      <section className="bg-[#F8FAFC] border-b border-slate-200 py-14">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#1A237E]">What's Included in Your Mobile Kitchen</h1>
          <p className="mt-5 text-lg text-slate-600 max-w-3xl leading-relaxed">
            When choosing a temporary kitchen with Mobile Kitchen Company, you're getting a
            personal service dealing direct with a single point of contact every time. Our fully functioning
            kitchen is fully equipped with all the appliances you need most, professionally installed and
            connected on the day and ready to use.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 grid gap-10 md:grid-cols-2">
          {INCLUDED.map((item) => (
            <article key={item.title} className="border border-slate-200 rounded overflow-hidden bg-white shadow-sm" data-testid={`included-card-${item.title.toLowerCase().replace(/[\s&]+/g, "-")}`}>
              <img src={item.img} alt={item.alt} className="w-full aspect-[16/9] object-cover" />
              <div className="p-6">
                <h2 className="text-xl sm:text-2xl font-semibold text-[#1A237E]">{item.title}</h2>
                <p className="mt-3 text-base text-slate-700 leading-relaxed">{item.text}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="py-16 bg-[#F8FAFC] border-y border-slate-200">
        <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1A237E]">Plus Everything Else You Need</h2>
            <p className="mt-4 text-base text-slate-700 leading-relaxed">
              Our temporary kitchen hire Surrey service is designed to be completely hassle-free. Along with
              the main appliances, every hire includes:
            </p>
            <ul className="mt-6 space-y-3">
              {EXTRAS.map((extra) => (
                <li key={extra} className="flex items-start gap-3 text-base text-slate-700">
                  <Check className="h-5 w-5 mt-0.5 shrink-0 text-[#1A237E]" />
                  {extra}
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-[#1A237E] rounded p-8 text-center">
            <h3 className="text-xl font-semibold text-white">Ready to Book Your Temporary Kitchen?</h3>
            <p className="mt-3 text-slate-300 text-sm leading-relaxed">
              Tell us your dates and we'll provide a clear, competitive quote for mobile kitchen hire in Surrey.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
              <Link to="/contact" data-testid="included-quote-button" className="px-6 py-3 bg-white text-[#1A237E] font-semibold rounded hover:bg-slate-100 transition-colors">
                Get a Free Quote
              </Link>
              <a href={PHONE_TEL} data-testid="included-call-button" className="flex items-center justify-center gap-2 px-6 py-3 bg-white text-[#1A237E] font-semibold rounded hover:bg-slate-100 transition-colors">
                <Phone className="h-4 w-4" /> {PHONE}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
